import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a6a0b42a875aa0014af77c6_1785963413563_4845a734/maximumeffort/src/app/global-error.tsx");
